import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var BatteryChargeIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M10.787 17.795a.5.5 0 0 1-.895-.385l.638-3.487a.5.5 0 0 0-.492-.59H7.984a.5.5 0 0 1-.406-.792c.98-1.343 3.016-4.135 4.618-6.336a.5.5 0 0 1 .895.385l-.638 3.487a.5.5 0 0 0 .492.59h2.07a.5.5 0 0 1 .404.795l-4.632 6.333Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M10.787 17.795a.5.5 0 0 1-.895-.385l.638-3.487a.5.5 0 0 0-.492-.59H7.984a.5.5 0 0 1-.406-.792l.406-.556.106-.146.004-.006c.884-1.21 2.17-2.975 3.355-4.602l.236-.325.37-.506.141-.195a.5.5 0 0 1 .895.385l-.638 3.487a.5.5 0 0 0 .492.59h2.07a.5.5 0 0 1 .404.795l-4.632 6.333Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M8.5 18H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h8.643l-1.05 1.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6.755L8.5 18Zm3.787 0H21a1 1 0 0 0 1-1v-1.5h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-1V7a1 1 0 0 0-1-1h-6.509l-.25 1.5H20.5V10h2v4h-2v2.5h-7.16L12.288 18Z",
                clipRule: "evenodd"
            })
        ]
    }));
};
